import { classNameMerger } from '@breetometer/utils';
import { FiatIcon } from 'BreetAssets';

import type { FiatInputProps } from '../../FiatInput.helpers';
import { FiatInputErrorComponent } from '../Error';
import FiatDropDown from '../FiatDropDown';
import { FiatInputComponent } from '../Input';
import { FiatInputLabel } from '../Label';
import { FiatInputMaxComponent } from '../Max';
import { FiatInputTooltip } from '../Tooltip';

const DefaultFiatInput = ({
	id,
	value,
	label,
	icon,
	currencyCode,
	errorMessage,
	message,
	walletDetails,
	handleMaxClick,
	dropDown,
	hideTooltip,
	wrapperClass,
	hideCurrencyCode,
	tooltip,
	...rest
}: FiatInputProps) => {
	const balanceCurrencyCode = !rest.disabled && walletDetails ? `Balance: ${walletDetails.currencyAmount}` : currencyCode;

	const isMaxFeat = typeof handleMaxClick === 'function';

	return (
		<div className={classNameMerger('fiat_input', wrapperClass)}>
			<FiatInputTooltip
				hideTooltip={hideTooltip}
				value={value}
			/>

			<div className={`fiat_input_wrapper bg-primary-500 ${isMaxFeat ? '' : 'no-max'}`}>
				<FiatInputLabel
					id={id}
					label={label}
					tooltip={tooltip}
				/>

				<div className='fiat_input_component_wrapper'>
					<FiatInputComponent
						{...rest}
						value={value}
						currencyCode={currencyCode}
						hideCurrencyCode={hideCurrencyCode}
					/>

					<div className='fiat_input_balance bg-primary-400 border-dark-navy'>
						{!dropDown?.selectedOption?.label && !dropDown?.defaultOption?.label ? (
							<>
								{icon ?? <FiatIcon currencyCode={currencyCode} />}

								<p className='fiat_input_balance_amount color-neutral-50'>{balanceCurrencyCode}</p>
							</>
						) : (
							<FiatDropDown {...dropDown} />
						)}
					</div>
				</div>

				<FiatInputMaxComponent
					isMaxFeat={isMaxFeat}
					handleMaxClick={handleMaxClick}
				/>
			</div>

			<FiatInputErrorComponent
				errorMessage={errorMessage}
				message={message}
			/>
		</div>
	);
};

export default DefaultFiatInput;
